import { createContext } from 'react'

/**
 * App session context.
 * - `character`: active/main actor for RP (from GET /api/v1/characters/init). Not the viewed sheet.
 * - Sheet UI uses Redux `inventory.character` for whatever slug is open.
 * - Use `getCharacterId()` from utils/characterId for a canonical id across both shapes.
 * - Call `refreshActiveCharacter()` after changeMain so adventure/missions see the new main.
 */
const AppContext = createContext({
  user: null,
  setUser: () => {},
  character: null,
  setCharacter: () => {},
  refreshActiveCharacter: async () => {},
  logout: () => {},
  // Permisos del usuario (RBAC)
  userPermissions: [],
  setUserPermissions: () => {},
  hasPermission: () => false,
})

export default AppContext
